export default "__VITE_ASSET__BjSaZFvs__"